import { Injectable, effect, signal } from '@angular/core';

const STORAGE_KEY = 'dime-theme';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  readonly darkMode = signal<boolean>(this._loadInitialTheme());

  constructor() {
    effect(() => {
      const isDark = this.darkMode();
      document.documentElement.classList.toggle('dark', isDark);
      try {
        localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
      } catch {}
    });
  }

  toggle(): void {
    this.darkMode.update((v) => !v);
  }

  private _loadInitialTheme(): boolean {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored !== null) {
        return stored === 'dark';
      }
    } catch {}
    // Fallback: preferencia del sistema operativo
    return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
  }
}
